import React from 'react';
import styled from 'styled-components';

import css from 'css';

/*
|--------------------------------------------------------------------------
|  H1
|--------------------------------------------------------------------------
*/
export const H1 = props => {
    return <H1Tag onClick={props.onClick ? props.onClick : null}>{props.children}</H1Tag>
}
export const h1Styles = `
    ${css.fonts.SpectralBold}
    ${css.mixins.fluidType(24, 64)}
    line-height: 1.14;
    @media (max-width:768px) {
        
    }
`;
export const h1SmallStyles = `
    ${css.fonts.SpectralBold}
    ${css.mixins.fluidType(24, 34)}
    line-height: 1.14;
    @media (max-width:768px) {
        
    }
`
const H1Tag = styled.h1` ${h1Styles} `;

/*
|--------------------------------------------------------------------------
|  H2
|--------------------------------------------------------------------------
*/
export const H2 = props => {
    if(props.html) {
        return <H2Tag dangerouslySetInnerHTML={{ __html: props.children }} onClick={props.onClick ? props.onClick : null} />
    }
    return <H2Tag onClick={props.onClick ? props.onClick : null}>{props.children}</H2Tag>
}
export const h2Styles = `
    ${css.fonts.SSProSemiBold}
    ${css.mixins.fluidType(20, 32)}
    line-height: 1.31;
    @media (max-width:768px) {
        
    }
`;
const H2Tag = styled.h2` ${h2Styles} `;

/*
|--------------------------------------------------------------------------
|  H3
|--------------------------------------------------------------------------
*/
export const H3 = props => {
    if(props.html) {
        return <H3Tag dangerouslySetInnerHTML={{ __html: props.children }} onClick={props.onClick ? props.onClick : null} />
    }
    return <H3Tag onClick={props.onClick ? props.onClick : null}>{props.children}</H3Tag>
}
export const h3Styles = `
    ${css.fonts.SSProRegular}
    ${css.mixins.fluidType(18, 24)}
    line-height: 1.41;
    @media (max-width:768px) {
        
    }
`;
const H3Tag = styled.h3` ${h3Styles} `;

/*
|--------------------------------------------------------------------------
|  H4
|--------------------------------------------------------------------------
*/
export const H4 = props => {
    return <H4Tag onClick={props.onClick ? props.onClick : null}>{props.children}</H4Tag>
}
export const h4Styles = `
    ${css.fonts.SSProRegular}
    ${css.mixins.fluidType(16, 20)}
    line-height: 1.5;
    @media (max-width:768px) {
        
    }
`;
const H4Tag = styled.h4` ${h4Styles} `;

/*
|--------------------------------------------------------------------------
|  H5
|--------------------------------------------------------------------------
*/
export const H5 = props => {
    return <H5Tag onClick={props.onClick ? props.onClick : null}>{props.children}</H5Tag>
}
export const h5Styles = `
    ${css.fonts.SSProRegular}
    font-size: 18px;
    line-height: 28px;
    @media (max-width:768px) {
        
    }
`;
const H5Tag = styled.h5` ${h5Styles} `;

/*
|--------------------------------------------------------------------------
|  H6
|--------------------------------------------------------------------------
*/
export const H6 = props => {
    return <H6Tag onClick={props.onClick ? props.onClick : null}>{props.children}</H6Tag>
}
export const h6Styles = `
    ${css.fonts.SSProRegular}
    font-size: 16px;
    line-height: 26px;
    @media (max-width:768px) {
        
    }
`;
const H6Tag = styled.h6` ${h6Styles} `;

/*
|--------------------------------------------------------------------------
|  p
|--------------------------------------------------------------------------
*/
export const P = props => {
    return <PTag onClick={props.onClick ? props.onClick : null}>{props.children}</PTag>
}
export const pStyles = `
    ${css.fonts.SSProRegular}
    font-size: 16px;
    line-height: 24px;
    overflow:hidden;
`;
const PTag = styled.p` ${pStyles} `;





// WEBPACK FOOTER //
// ./src/partials/typography/index.js